// extracted by mini-css-extract-plugin
export default {"section-header":"gOmdIBvYfNPijg5Mambg"};